module.exports = __webpack_public_path__ + "img/upx1.472011e9.svg";